'use client';
var classes = {"dropdown":"m_38a85659","arrow":"m_a31dc6c1","overlay":"m_3d7bc908"};

export { classes as default };
//# sourceMappingURL=Popover.module.css.mjs.map
